import * as React from 'react';
import SVGUniqueID from 'react-svg-unique-id';

interface PaymentHistoryPendingIconProps {
  width?: number;
  height?: number;
}

const PaymentHistoryPendingIcon: React.FC<PaymentHistoryPendingIconProps> = ({
  width = 18,
  height = 18
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.334 9.833H9A.833.833 0 018.167 9V5.667a.833.833 0 111.667 0v2.5h2.5a.833.833 0 110 1.666zM9 .667C4.405.667.667 4.405.667 9c0 4.595 3.738 8.333 8.333 8.333 4.595 0 8.334-3.738 8.334-8.333C17.334 4.405 13.595.667 9 .667z"
        fill="#F0B429"
      />
    </svg>
  </SVGUniqueID>
);

export { PaymentHistoryPendingIcon };
